import { makeStyles } from "@material-ui/core/styles";

const SMQ_MENU_FONT_ID = "smq-menu-fonts";

if (typeof document !== "undefined" && !document.getElementById(SMQ_MENU_FONT_ID)) {
  const link = document.createElement("link");
  link.id = SMQ_MENU_FONT_ID;
  link.rel = "stylesheet";
  link.href =
    "https://fonts.googleapis.com/css2?family=DM+Mono:wght@400;500&family=DM+Sans:wght@300;400;500;600;700&display=swap";
  document.head.appendChild(link);
}

const useSMQSidebarStyles = makeStyles(() => ({
  sidebarRoot: {
    width: "100%",
    height: "100%",
    overflowY: "auto",
    overflowX: "hidden",
    padding: "6px 0 16px",
    backgroundColor: "#ffffff",
    color: "#5a6b8c",
    fontFamily: "'DM Sans', sans-serif",
    scrollbarWidth: "thin",
    scrollbarColor: "#cdd5e8 transparent",
    "&::-webkit-scrollbar": {
      width: 6,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#cdd5e8",
      borderRadius: 6,
    },
  },
  section: {
    width: "100%",
  },
  sectionTitle: {
    padding: "12px 16px 4px",
    color: "#94a3b8",
    fontFamily: "'DM Sans', sans-serif",
    fontSize: 10,
    fontWeight: 600,
    letterSpacing: 1.5,
    lineHeight: 1.4,
    textTransform: "uppercase",
  },
  accordionButton: {
    display: "flex",
    alignItems: "center",
    width: "calc(100% - 20px)",
    minHeight: 38,
    margin: "8px 10px 3px",
    padding: "8px 12px",
    border: 0,
    borderRadius: 10,
    backgroundColor: "transparent",
    color: "#64748b",
    cursor: "pointer",
    fontFamily: "'DM Sans', sans-serif",
    fontSize: 10,
    fontWeight: 600,
    letterSpacing: 1.5,
    lineHeight: 1.4,
    textAlign: "left",
    textTransform: "uppercase",
    transition: "background-color 150ms ease, color 150ms ease",
    "&:hover": {
      backgroundColor: "#f4f8fc",
      color: "#0f1a2e",
    },
    "&:focus-visible": {
      outline: "2px solid #00a3b4",
      outlineOffset: 2,
    },
  },
  accordionButtonOpen: {
    color: "#0f6672",
    backgroundColor: "#f0fbfc",
  },
  accordionLabel: {
    flex: 1,
    minWidth: 0,
  },
  chevron: {
    width: 18,
    height: 18,
    marginLeft: 8,
    color: "currentColor",
    fontSize: 18,
    lineHeight: "18px",
    textAlign: "center",
    transform: "rotate(-90deg)",
    transition: "transform 180ms ease",
  },
  chevronOpen: {
    transform: "rotate(0deg)",
  },
  accordionPanel: {
    width: "100%",
  },
  menuList: {
    margin: 0,
    padding: 0,
    listStyle: "none",
  },
  menuItem: {
    margin: "3px 10px",
  },
  menuLink: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    width: "100%",
    minHeight: 40,
    gap: 10,
    padding: "7px 12px",
    border: "1px solid transparent",
    borderRadius: 10,
    backgroundColor: "transparent",
    color: "#64748b",
    fontFamily: "'DM Sans', sans-serif",
    fontSize: 12.5,
    fontWeight: 500,
    lineHeight: 1.35,
    textDecoration: "none",
    transition:
      "background-color 150ms ease, border-color 150ms ease, color 150ms ease, box-shadow 150ms ease",
    "&:hover": {
      backgroundColor: "#eef8fa",
      color: "#0f6672",
      textDecoration: "none",
    },
    "&:focus-visible": {
      outline: "2px solid #00a3b4",
      outlineOffset: 2,
    },
  },
  menuLinkActive: {
    borderColor: "rgba(0, 163, 180, 0.18)",
    backgroundColor: "#e9f8fa",
    color: "#007f8d",
    boxShadow: "inset 3px 0 0 #00a3b4",
    fontWeight: 600,
    "&:hover": {
      backgroundColor: "#e3f5f7",
      color: "#007f8d",
    },
  },
  icon: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: 28,
    height: 28,
    flexShrink: 0,
    borderRadius: 7,
    backgroundColor: "#f1f5f9",
    fontSize: 14,
    lineHeight: 1,
  },
  iconActive: {
    backgroundColor: "rgba(0, 163, 180, 0.13)",
  },
  itemLabel: {
    flex: 1,
    minWidth: 0,
    overflowWrap: "anywhere",
  },
  badge: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: 20,
    height: 20,
    flexShrink: 0,
    padding: "0 6px",
    borderRadius: 10,
    backgroundColor: "rgba(0, 163, 180, 0.12)",
    color: "#007f8d",
    fontFamily: "'DM Mono', monospace",
    fontSize: 9,
    fontWeight: 500,
    lineHeight: 1,
  },
  nestedList: {
    paddingBottom: 4,
  },
}));

export default useSMQSidebarStyles;
